export default "__VITE_PUBLIC_ASSET__8a88ca47__"